import { DEFAULT_SENDER_ID_NAME, DEFAULT_SENDER_ID_VALUE } from '@/app/definitions'
import { SelectOption } from '@/app/types'

export const getSmsSenderIds = (
  defaultSenderId: SelectOption<string> | undefined,
  senderIds: SelectOption<string>[],
) => {
  const options = [
    ...(defaultSenderId ? [defaultSenderId] : []),
    {
      label: DEFAULT_SENDER_ID_NAME,
      value: DEFAULT_SENDER_ID_VALUE,
    },
    ...senderIds,
  ]

  return options.filter((option, index) => options.findIndex(({ value }) => value === option.value) === index)
}
